// For consistency, we are using styled-system - docs: https://github.com/jxnblk/styled-system#docs
import images from './Images';
import { ThemeType } from './ThemeInterface';
import { BREAKPOINTS, media } from './breakpoints';

const theme: ThemeType = {
  fontSize: ['16px', '20px', '24px', '64px', '206px'],
  space: [0, 5, 10, 15, 20, 40, 80],
  zIndex: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150],
  fontFamily: 'Roboto Condensed, sans-serif',
  colors: {
    textDefault: '#404040',
    primary: '#3d484a',
    secondary: '#4c995b',
    tertiary: 'rgb(223, 183, 80)',
    htmlBackground: '#f5f5f5',

    black: '#000000',
    white: '#FFFFFF',
    blue: '#79d8f2',

    success: '#4c9a5c',
    warning: '#e6b636',
    error: '#cc0000',

    transparent: 'rgba(0,0,0,0)',
    transparentBlack: 'rgba(0,0,0,0.3)',
    transparentPrimary: 'rgba(61,72,74,0.6)',
    transparentWhite: 'rgba(255,255,255, 0,4)',

    // IB-1885 surface tokens: neutral greys tuned to sit alongside the ImpactBoard primary
    surface: '#FFFFFF',
    surfaceMuted: '#f8f9f9',
    border: '#e3e6e6',
    focusRing: 'rgba(76,153,91,0.45)',
  },
  minWidths: ['160px'],
  // Keyed scales (not arrays) on purpose: styled-system resolves a number such as
  // borderRadius={4} against an array scale by index, which would change existing components.
  radii: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    pill: '999px',
  },
  shadows: {
    sm: '0 1px 2px rgba(16,24,40,0.06), 0 1px 3px rgba(16,24,40,0.08)',
    md: '0 4px 12px rgba(16,24,40,0.08), 0 1px 3px rgba(16,24,40,0.06)',
    lg: '0 12px 32px rgba(16,24,40,0.12)',
  },
  // Not named `breakpoints`: styled-system would pick that up and shift every responsive array prop.
  screens: BREAKPOINTS,
  media,
};

export type TenantBranding = {
  primary?: string;
  secondary?: string;
  tertiary?: string;
  htmlBackground?: string;
  fontFamily?: string;
};

// Groundwork for tenant (organisation) branding in later tickets: returns the ImpactBoard theme
// with a tenant's colours layered on top, leaving anything they don't set on the ImpactBoard CI.
export const createTenantTheme = (branding?: TenantBranding | null): ThemeType => {
  if (!branding) {
    return theme;
  }
  const { fontFamily, ...colors } = branding;
  const definedColors = Object.keys(colors).reduce(
    (acc, key) => (colors[key] ? { ...acc, [key]: colors[key] } : acc),
    {}
  );
  return {
    ...theme,
    fontFamily: fontFamily || theme.fontFamily,
    colors: { ...theme.colors, ...definedColors },
  };
};

export { theme, images };
